import React from "react";
import "./Checkbox.css";

const Checkbox = ({
  className = "",
  onClick = () => {},
  isChecked = false,
  name = "name",
  label
}) => (
  <label className={`checkboxInput ${className}`}>
    <input
      type="checkbox"
      className={`checkboxInput__checkbox`}
      onClick={onClick}
      defaultChecked={isChecked}
      autoComplete="off"
      name={name}
    />
    <span className="checkboxInput__checkmark"> </span>
    {label}
  </label>
);

export default Checkbox;
